import { alpha } from '@mui/material/styles';

export const aiAnalysisDialogStyles = {
  title: (titleColor) => ({
    fontWeight: 'bold',
    color: titleColor,
  }),
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
  },
  errorAlert: {
    mb: 2,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
};

export const reportStyles = {
  sectionHeader: {
    mb: 3,
  },
  sectionTitle: {
    fontWeight: 800,
    mb: 0.5,
  },
  metricsGrid: {
    mb: 3,
  },
  sectionDivider: {
    mb: 3,
  },
  reportPaper: {
    p: 2,
    height: '100%',
  },
  reportPaperWithMargin: {
    p: 2,
    mb: 3,
  },
  sectionToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
    mb: 2,
    flexWrap: 'wrap',
  },
  subsectionTitle: {
    fontWeight: 800,
  },
  sectionDescription: {
    mt: 0.5,
    mb: 2,
  },
  breakdownList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  breakdownRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
    mb: 0.5,
  },
  breakdownLabel: {
    fontWeight: 700,
  },
  breakdownProgress: (color, count) => ({
    height: 8,
    borderRadius: 1,
    bgcolor: (theme) => alpha(theme.palette[color].main, 0.12),
    '& .MuiLinearProgress-bar': {
      bgcolor: count > 0 ? `${color}.main` : 'success.main',
    },
  }),
  tableHeaderCell: {
    fontWeight: 800,
  },
  wordBreakCell: {
    wordBreak: 'break-word',
  },
};

export const fallbackStyles = {
  heading: {
    mb: 2,
    fontWeight: 'bold',
  },
  analysisHeading: {
    mt: 3,
    mb: 2,
    fontWeight: 'bold',
  },
  failedAttributeCard: {
    p: 2,
    mb: 2,
    bgcolor: 'custom.surfaceAlt',
  },
  flowAnalysisPaper: {
    p: 2,
    bgcolor: (theme) => alpha(theme.palette.success.main, 0.12),
  },
  regressionAnalysisPaper: {
    p: 2,
    bgcolor: (theme) => alpha(theme.palette.secondary.main, 0.12),
  },
  analysisText: {
    whiteSpace: 'pre-wrap',
    fontFamily: 'Roboto, sans-serif',
    lineHeight: 1.6,
  },
  preAnalysisText: {
    m: 0,
    whiteSpace: 'pre-wrap',
    fontFamily: 'Roboto, sans-serif',
    lineHeight: 1.6,
  },
};

export const metricCardStyles = {
  card: {
    p: 2,
    height: '100%',
    borderColor: (theme) => alpha(theme.palette.divider, 0.8),
    bgcolor: 'background.paper',
  },
  label: {
    display: 'block',
    mb: 0.5,
  },
  value: (toneColor) => ({
    fontWeight: 800,
    color: toneColor,
    lineHeight: 1.2,
  }),
  helper: {
    display: 'block',
    mt: 0.75,
  },
};

export const emptyReportSectionStyles = {
  py: 2,
  textAlign: 'center',
  bgcolor: 'custom.surfaceAlt',
  borderRadius: 1,
};
